let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jzyrG")).then(() => parcelRequire('9qYpf'));